import { render, staticRenderFns } from "./own.vue?vue&type=template&id=5d1c42ae&"
import script from "./own.vue?vue&type=script&lang=js&"
export * from "./own.vue?vue&type=script&lang=js&"
import style0 from "./own.vue?vue&type=style&index=0&id=5d1c42ae&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports